import { getArtigosRecentes } from "@/lib/blog.functions";
import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { MedicinaDoEsporte, faq } from "@/components/itv/pages/MedicinaDoEsporte";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { getSiteData } from "@/lib/site-data.functions";
import {
  breadcrumbSchema,
  faqSchema,
  medicalWebPageSchema,
  physicianSchema,
  type Trilha,
} from "@/lib/schema";

const PATH = "/tratamentos/medicina-do-esporte/";
const TITLE = "Medicina do Esporte para Praticantes | Dr. Thiago Viana";
const DESCRIPTION =
  "Acompanhamento médico esportivo para rendimento, prevenção de lesões, recuperação muscular e nutrição equilibrada para quem treina com regularidade.";

export const Route = createFileRoute("/tratamentos/medicina-do-esporte")({
  loader: async () => {
    const [site, head, artigos] = await Promise.all([getSiteData(), carregarPaginaSimples(PATH, TITLE, DESCRIPTION), getArtigosRecentes()]);
    return { site, artigos, ...head };
  },
  staticData: { declaraPhysician: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const { site, artigos } = Route.useLoaderData();
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: "/tratamentos/" },
    { nome: "Medicina do esporte", path: PATH },
  ];

  return (
    <>
      <MedicinaDoEsporte artigos={artigos} />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
      <JsonLd data={faqSchema(faq)} />
      <JsonLd data={physicianSchema(site.doctor, "completa")} />
    </>
  );
}
